export const config = {
  title: "Expandable Services LLC | Philadelphia, PA | Building Better Homes Together",
  meta: {
    description:
      "Expandable Services LLC provides professional construction and home building services in Philadelphia, PA. Expert general contracting, home renovations, remodeling, and custom construction. Building Better Homes Together.",
    keywords: [
      "Expandable Services LLC",
      "Philadelphia Construction",
      "Home Building Philadelphia",
      "General Contractor Philadelphia",
      "Home Renovation Philadelphia PA",
      "Construction Services Philadelphia",
      "Custom Home Builder",
      "Remodeling Contractor Philadelphia"
    ],
    author: "Expandable Services LLC",
    canonicalUrl: "https://expandableservicesllc.com/",
  },
  sections: {
    header: {
      businessName: "Expandable Services LLC",
    },
    sectionB: {
      heroTitle: "Building Better Homes Together",
      heroSubtitle: "Professional Construction & Home Building Services in Philadelphia",
      learnAboutText: "Contact Us Today",
      phoneNumber: "2674998241",
      phoneLabel: "(267) 499-8241",
      heroBackgroundImage:
        "https://media.istockphoto.com/id/1042342584/photo/investors-and-contractors-on-construction-site.jpg?s=612x612&w=0&k=20&c=dfpqU0nr9BccCHOdHNyI1UanHGLt1nD2t6jZp95YUe4=",
      cardData: [
        {
          title: "New Construction",
          description:
            "Custom home building and new construction projects built to your specifications.",
        },
        {
          title: "Home Renovations",
          description:
            "Complete home renovation and remodeling services to transform your living space.",
        },
        {
          title: "General Contracting",
          description:
            "Full-service general contracting for residential and commercial projects.",
        },
      ],
      description:
        "Expandable Services LLC is your trusted partner for construction and home building in Philadelphia, PA. We're dedicated to building better homes together through quality craftsmanship and exceptional service.",
    },
    sectionC: {
      servicesTitle: "Our Construction Services",
      servicesDescription:
        "Comprehensive construction and building solutions for residential and commercial properties in Philadelphia. From new home construction to complete renovations, we deliver quality results that exceed expectations.",
      cards: [
        {
          title: "New Home Construction",
          description:
            "Custom home building services from foundation to finish. We work closely with you to bring your dream home to life with expert craftsmanship and attention to detail.",
          imageSrc: "https://images.unsplash.com/photo-1503387762-592deb58ef4e?w=600&q=80",
          imageAlt: "New home construction",
        },
        {
          title: "Home Renovations & Remodeling",
          description:
            "Transform your existing home with our complete renovation services. Kitchen and bathroom remodeling, room additions, and whole-home renovations.",
          imageSrc: "https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?w=600&q=80",
          imageAlt: "Home renovation project",
        },
        {
          title: "General Contracting",
          description:
            "Professional general contracting services for all types of construction projects. Licensed and insured for your peace of mind.",
          imageSrc: "https://images.unsplash.com/photo-1541888946425-d81bb19240f5?w=600&q=80",
          imageAlt: "Construction site management",
        },
      ],
      otherServicesTitle: "Additional Services",
      otherServicesList: [
        "Home Additions",
        "Kitchen Remodeling",
        "Bathroom Renovations",
        "Structural Framing",
        "Commercial Construction",
        "Project Management",
      ],
    },
    sectionD: {
      aboutTitle: "About Expandable Services LLC",
      aboutImage: {
        src: "https://images.unsplash.com/photo-1504307651254-35680f356dfd?w=800&q=80",
        alt: "Construction team at work",
      },
      aboutText: [
        "Expandable Services LLC is a professional construction and home building company serving Philadelphia, PA and the surrounding areas. With a commitment to quality craftsmanship and customer satisfaction, we specialize in bringing your construction vision to life.",
        "Our tagline 'Building Better Homes Together' reflects our collaborative approach to every project. We believe that the best results come from working closely with our clients, understanding their needs, and delivering solutions that exceed expectations.",
        "Whether you're planning a new home construction, complete renovation, or commercial building project, our experienced team provides the expertise and dedication needed to ensure success. We handle every aspect of your project with professionalism and care, from initial planning through final completion.",
      ],
    },
    sectionE: {
      profileImage: null,
      profileAlt: "Expandable Services LLC Logo",
      businessName: "Expandable Services LLC",
      contact: {
        phone: "2674998241",
        phoneLabel: "(267) 499-8241",
        email: "yourexpendableservices1@gmail.com",
        website: "https://expandableservicesllc.com/",
        address: "Philadelphia, PA",
      },
      socialMedia: {},
    },
    sectionF: {
      address: "Philadelphia, PA",
      googleMapsEmbedUrl:
        "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d195429.6!2d-75.1652!3d39.9526!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c6b7d8d4b54beb%3A0x89f514d88c3e58c1!2sPhiladelphia%2C%20PA!5e0!3m2!1sen!2sus!4v1730400000000!5m2!1sen!2sus",
    },
  },
};

export default config;